import React from 'react';
import { Card } from "tea-component";
import classnames from 'classnames';
import './index.scss';

const GTDROverview = (props: any) => {
  const {
    children,
    className,
    style,
    ...resetProps
  } = props;

  return (
    <Card className={classnames('dbd-gtdr-overview', className)} style={style}>
      {React.Children.map(children, (child: any) =>
        React.cloneElement(child, {
          ...resetProps,
        }),
      )}
    </Card>
  );
};

export default GTDROverview;
